module.exports = __webpack_public_path__ + "static/mtb-2-093c7bd1dfc94ce8d30daccec6965e8e.jpg";